var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container_PFormSwitch"},[_c('div',{class:_vm.giveMeClassSwitch,on:{"click":_vm.change}},[_c('div')]),_c('div',{staticClass:"label_PFormSwitch"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }